export namespace AppRoute {
    export enum Root {
        Auth = 'auth',
        Home = 'home',
        Billing = 'billing',
        Communities = 'communities',
        Settings = 'settings',
        Api = 'api',
        LinkAccount = 'link-account',
        FinishPasswordlessSignIn = 'finish-passwordless-sign-in'
    }

    export enum Communities {
        List = 'list',
        Details = 'details'
    }

    export enum CommunitiesDetails {
        Statistics = 'statistics',
        Settings = 'settings',
        History = 'history'
    }
}
